// src/lib/base64url.ts
// Convert base64url -> base64 without using .replace()
export function base64urlToBase64(input: unknown): string | null {
  const s = (input ?? "").toString();
  if (!s) return null;

  let out = "";
  for (let i = 0; i < s.length; i++) {
    const ch = s.charCodeAt(i);
    if (ch === 45) out += "+"; // '-'
    else if (ch === 95) out += "/"; // '_'
    else out += s[i];
  }
  // pad to multiple of 4
  const pad = (4 - (out.length % 4)) % 4;
  if (pad) out += pad === 1 ? "=" : pad === 2 ? "==" : "===";
  return out;
}

export function decodeBase64urlToString(input: unknown): string | null {
  const b64 = base64urlToBase64(input);
  if (!b64) return null;
  try {
    return atob(b64);
  } catch {
    return null;
  }
}
